import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import instaIcon from '@/assets/insta-icon-optimized.webp';

const InstagramFloat = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { pathname } = useLocation();

  // En la biblioteca de prompts y en el admin el flotante tapa botones
  // de tarjetas y controles; ahí no se muestra.
  if (pathname.startsWith('/prompts') || pathname.startsWith('/admin')) {
    return null;
  }

  const handleClick = () => {
    window.open('https://www.instagram.com/aiautobaseteam/', '_blank');
  };

  return (
    <div className="fixed bottom-[60px] right-4 md:right-[100px] z-50">
      <div className="relative">
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 px-2 py-1.5 md:px-3 md:py-2 bg-card border border-border rounded-lg shadow-lg text-[10px] sm:text-xs md:text-sm text-foreground max-w-[160px] sm:max-w-[200px] md:max-w-none md:whitespace-nowrap leading-tight md:leading-normal animate-fade-in">
            📩 If you need any help or have questions, feel free to DM me.
            <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-border"></div>
          </div>
        )}
        
        {/* Instagram Icon */}
        <button 
          type="button"
          aria-label="Contact us on Instagram for help"
          className="relative cursor-pointer transition-all duration-300 hover:scale-110 hover:rotate-12 group bg-transparent border-0 p-0"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={handleClick}
        >
          <img 
            src={instaIcon}
            alt=""
            width="70"
            height="70"
            loading="lazy"
            decoding="async"
            className="w-[70px] h-[70px] rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:shadow-primary/20"
            aria-hidden="true"
          />
          
          {/* Glow effect on hover */}
          <div className="absolute inset-0 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-xl blur-sm -z-10" aria-hidden="true"></div>
        </button>
      </div>
    </div>
  );
};

export { InstagramFloat };